import { useTranslation } from '@mukil/i18n';
import { Alert } from '@jumpstone/ui-react';

/**
 * The ONE rendering of "this draft pay run is blocked because a worker on it
 * is now recorded as a contractor" (WagePro worker types). Used by the
 * wizard's totals card, its statutory step and its approval step, so the
 * blocked state reads identically everywhere and a future copy change has
 * exactly one place to go.
 *
 * Shown in place of money figures: a blocked draft's preview totals are
 * placeholder zeros from the API (`blocked_contractor_count` on
 * `getPayRunJournalPreview`), never real amounts, and `approvePayRun`
 * refuses the run outright (`PAYROLL_PAY_RUN_HAS_CONTRACTOR`). The only way
 * forward is deleting the draft and creating it again — contractors are left
 * out automatically. A `warning` Alert: the draft genuinely cannot be
 * approved until the user acts, so the semantic tone matches the condition.
 */
export function PayRunContractorBlockedBanner({
  count,
}: {
  /** Workers on the draft now recorded as contractors; `0` when only the approve refusal is known. */
  count: number;
}): React.JSX.Element {
  const { t } = useTranslation('wp');
  return (
    <Alert
      variant="warning"
      data-testid="pay-run-contractor-blocked"
      title={t('pay_run.blocked_contractor_title')}
    >
      {t('pay_run.blocked_contractor_body', { count })}
    </Alert>
  );
}
